import CONNECTION_TYPE from '../common/connection-type';

export const ASSIGN_RX_COLUMN = {
  PRESCRIPTION_ID: 'rxNo',
  FILL_ID: 'fillNumber',
  PRESCRIPTION_NUMBER: 'PrescriptionNumber',
  ORDER_ID: 'OrderId',
  TRANSACTION_ID: 'TranactionId',
  DRUG_NAME: 'name',
  NDC: 'ndcCode',
  QTY: 'qty',
  CONTROLLED: 'iscontrolledsubstance',
  CONSULT: 'consultrequire',
  RETURNABLE: 'isreturnable',
  AMOUNT_DUE: 'AmountDue',
};

const COLUMN = ASSIGN_RX_COLUMN;
const ALL_COLUMNS = Object.values(COLUMN);

/**
 * Columns the deliver/assign cart leaves blank for that connection type.
 * Is Returnable stays visible for every type.
 */
const HIDDEN_COLUMNS_BY_CONNECTION = {
  [CONNECTION_TYPE.ILOCALBOX_PHARMACY]: [
    COLUMN.FILL_ID,
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.BASIC]: [
    COLUMN.FILL_ID,
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.UNPLUGGED]: [
    COLUMN.FILL_ID,
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.LIBERTY_SOFTWARE]: [
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.MSCRIPTS]: [
    COLUMN.PRESCRIPTION_ID,
    COLUMN.NDC,
    COLUMN.QTY,
  ],
  [CONNECTION_TYPE.EPIC]: [
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.EPIC_WITH_MTLS]: [
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.PIONEERRX]: [
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.MCKESSONERX]: [
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.DRX_INTEGRATION]: [
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.MEDBANK]: [
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
  ],
  [CONNECTION_TYPE.QS1]: [
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
  ],
  [CONNECTION_TYPE.HL7]: [
    COLUMN.FILL_ID,
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.ORDER_ID,
    COLUMN.TRANSACTION_ID,
    COLUMN.AMOUNT_DUE,
  ],
  [CONNECTION_TYPE.PRIMERX]: [
    COLUMN.PRESCRIPTION_NUMBER,
    COLUMN.TRANSACTION_ID,
  ],
};

export const resolveAssignConnectionTypeId = (
  accountDetails,
  globalAccountConnection
) => {
  const fromAccount =
    accountDetails && accountDetails.connection && accountDetails.connection.id;
  const fromGlobal =
    globalAccountConnection && globalAccountConnection.account_connections_id;
  let fromSession = null;
  if (typeof sessionStorage !== 'undefined') {
    fromSession = sessionStorage.getItem('accountConnectionId');
  }
  return fromAccount || fromGlobal || fromSession || null;
};

export const getVisibleAssignColumns = (connectionTypeId) => {
  const hidden = HIDDEN_COLUMNS_BY_CONNECTION[connectionTypeId];
  if (!hidden) {
    return new Set(ALL_COLUMNS);
  }
  const hiddenIds = new Set(hidden);
  return new Set(ALL_COLUMNS.filter((columnId) => !hiddenIds.has(columnId)));
};

export const isAssignColumnVisible = (connectionTypeId, columnId) =>
  getVisibleAssignColumns(connectionTypeId).has(columnId);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/assignColumnVisibility.js